var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.path)?_c('b-button',{attrs:{"size":_vm.size,"variant":_vm.variant,"href":`${this.$config.files.staticServerUrl}/${this.path}`,"target":_vm.target}},[_c('font-awesome-icon',{staticClass:"mx-1",attrs:{"icon":_vm.icon}}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }